import React from "react"

const FitIcon = ({ style = {} }: { style?: React.CSSProperties }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
    >
      <g clipPath="url(#clip0_10214_4706)">
        <path
          d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5H40C44.4183 0.5 48 4.08172 48 8.5V40.5C48 44.9183 44.4183 48.5 40 48.5H8C3.58172 48.5 0 44.9183 0 40.5V8.5Z"
          fill="#00263A"
        />
        <mask
          id="mask0_10214_4706"
          maskUnits="userSpaceOnUse"
          x="-488"
          y="-488"
          width="1024"
          height="1025"
        >
          <rect x="-488" y="-487.5" width="1024" height="1024" fill="white" />
        </mask>
        <g mask="url(#mask0_10214_4706)">
          <path
            d="M38.1914 35.4261C33.443 35.4261 29.5769 31.5967 29.5769 26.8933V15.6465H33.7801V26.8933C33.7801 29.3018 35.7598 31.2627 38.1914 31.2627V35.4261Z"
            fill="white"
          />
          <path
            d="M19.2409 12.698C14.4926 12.698 10.6265 16.5275 10.6265 21.2308V34.8222H14.8297V21.2308C14.8297 18.8223 16.8094 16.8614 19.2409 16.8614V12.698Z"
            fill="white"
          />
          <path
            d="M26.6217 21.5293H22.4185V34.8223H26.6217V21.5293Z"
            fill="white"
          />
          <path
            d="M17.7275 26.0051C18.9793 26.0051 19.9941 24.9999 19.9941 23.76C19.9941 22.5201 18.9793 21.5149 17.7275 21.5149C16.4757 21.5149 15.4609 22.5201 15.4609 23.76C15.4609 24.9999 16.4757 26.0051 17.7275 26.0051Z"
            fill="#EF4D96"
          />
          <path
            d="M24.5273 20.0444C25.7791 20.0444 26.7939 19.0392 26.7939 17.7993C26.7939 16.5594 25.7791 15.5542 24.5273 15.5542C23.2755 15.5542 22.2607 16.5594 22.2607 17.7993C22.2607 19.0392 23.2755 20.0444 24.5273 20.0444Z"
            fill="#FA4614"
          />
          <path
            d="M36.7352 26.0051C37.987 26.0051 39.0018 24.9999 39.0018 23.76C39.0018 22.5201 37.987 21.5149 36.7352 21.5149C35.4834 21.5149 34.4686 22.5201 34.4686 23.76C34.4686 24.9999 35.4834 26.0051 36.7352 26.0051Z"
            fill="#2CCCD3"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_10214_4706">
          <path
            d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5H40C44.4183 0.5 48 4.08172 48 8.5V40.5C48 44.9183 44.4183 48.5 40 48.5H8C3.58172 48.5 0 44.9183 0 40.5V8.5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FitIcon
